import { render, staticRenderFns } from "./TransactionCard.vue?vue&type=template&id=16ab4666&scoped=true&"
import script from "./TransactionCard.vue?vue&type=script&lang=js&"
export * from "./TransactionCard.vue?vue&type=script&lang=js&"
import style0 from "./TransactionCard.vue?vue&type=style&index=0&id=16ab4666&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16ab4666",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VChip } from 'vuetify/lib/components/VChip';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemSubtitle } from 'vuetify/lib/components/VList';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VAvatar,VCard,VCardText,VChip,VList,VListItem,VListItemSubtitle,VSpacer})
